/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Index from "views/Index.js";
import Profile from "views/examples/Profile.jsx";
import Register from "views/examples/Register.jsx";
import Login from "views/examples/Login.jsx";
import Tables from "views/examples/Tables.js";
import Icons from "views/examples/Icons.js";
import Historique from "views/examples/Historique";
import MyDemands from "views/examples/MyDemands";
import AddDemande from "views/examples/AddDemande";
import Holidays from "views/examples/Holidays";
import SystemAdminDashboard from "views/admin/SystemAdminDashboard";
import AddPlan from "views/admin/AddPlan";
import PlansList from "views/admin/PlansList";
import EditPlan from "views/admin/EditPlan";
import AuditLogs from "views/admin/AuditLogs";
import SubscriptionsList from "views/admin/SubscriptionsList";
var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <SystemAdminDashboard />,
    layout: "/admin",
  },
  
  {
    path: "/profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/admin",
    sidebar: false
  },
  
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: <Login />,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: <Register />,
    layout: "/auth",
    sidebar: false
  },
  
{
    path: "/tenants",
    name: "Tenants",
    icon: "ni ni-building text-info",
    component: <Holidays />,
    layout: "/admin",
    
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    icon: "ni ni-credit-card text-success",
    component: <SubscriptionsList />,
    layout: "/admin",
  },
  {
    path: "/list-plan",
    name: "Plans",
    icon: "ni ni-bullet-list-67 text-primary",
    component: <PlansList />,
    layout: "/admin",
    
  },
  {
  path: "/add-plan",
  name: "Add Plan",
  icon: "ni ni-fat-add text-primary",
  component: <AddPlan />,
  layout: "/admin",
},
{
  path: "/edit-plan/:id",
  name: "Edit Plan",
  icon: "ni ni-fat-add text-primary",
  component: <EditPlan />,
  layout: "/admin",
  sidebar: false
},
{ path: "/logs",
   name: "Logs",
    icon: "ni ni-bullet-list-67 text-info",
     component: <AuditLogs />,
      layout: "/admin" },
];
export default routes;
